define('shared/initializer/form/adapters/Form',[
    'shared/lib/ctor',
    'shared/lib/RSVP',
    './Base',
    './mixins/ActionProvideable',
    'shared/util/dom/form/disable',
    'shared/util/dom/form/enable',
    'kernel/ui/Blocker'
],
function (
    ctor,
    RSVP,
    Base,
    ActionProvideable,
    disableForm,
    enableForm,
    BlockerUI
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply( null, arguments );
        me.mixin(
            ActionProvideable
        );
        me.ui = {};
        me.ui.blocker = new BlockerUI(me.$form[0]);
        me._blockCount = 0;
    }).inherit(Base);

    Ctor.prototype.disable = function() {
        var me = this;
        disableForm(me.$form);
        this.isDisabled = true;
        return RSVP.resolve();
    };

    Ctor.prototype.enable = function() {
        var me = this;
        enableForm(me.$form);
        this.isDisabled = false;
        return RSVP.resolve();
    };

    Ctor.prototype.block = function() {
        var me = this;
        if (me._blockCount === 0) {
            me._positionBeforeBlocked = me.$form.css('position');
            me.$form.css('position', 'relative');
            me.ui.blocker.block();
        }
        me._blockCount++;
        return RSVP.resolve();
    };

    Ctor.prototype.resume = function() {
        var me = this;
        me._blockCount--;
        if (me._blockCount === 0) {
            me.ui.blocker.resume();
            me.$form.css(
                'position', 
                me._positionBeforeBlocked
            );
        }
        return RSVP.resolve();
    };

    return Ctor;
});

